// Manifeste des textes éditables depuis Admin > Contenus.
// title = titre de page : une ligne par ligne affichée (la 2ème ligne s'affiche en or sur les pages avec grand titre).
export const CONTENT_GROUPS = [
  {
    group: "Accueil",
    fields: [
      { key: "home.hero.subtitle", label: "Texte d'accroche (sous le logo)", multiline: true, def: "L'organisation de stages de football et de matchs amicaux de haut niveau. L'expérience du jeu, l'exigence du professionnalisme." },
      { key: "home.ch1.title", label: "Section 01 — Titre", def: "Le Stage" },
      { key: "home.ch1.text", label: "Section 01 — Description", multiline: true, def: "Des stages de football pensés comme des expériences : éducateurs diplômés, groupes réduits, progression individuelle et cadre d'exception sur la Côte d'Azur." },
      { key: "home.ch2.title", label: "Section 02 — Titre", def: "Le Match" },
      { key: "home.ch2.text", label: "Section 02 — Description", multiline: true, def: "L'organisation de matchs amicaux professionnels et semi-professionnels : opposition de niveau, stades partenaires, logistique complète et événementiel maîtrisé." },
      { key: "home.clubs.title", label: "Section 03 — Titre (clubs)", def: "Ils nous font confiance" },
      { key: "home.clubs.text", label: "Section 03 — Description", multiline: true, def: "Clubs professionnels, clubs amateurs et sélections : ils nous confient leurs stages, leurs matchs amicaux et leurs événements." },
      { key: "home.boutique.title", label: "Section Boutique — Titre", def: "Boutique" },
    ],
  },
  {
    group: "Stage Payet",
    fields: [
      { key: "stagepayet.overline", label: "Sur-titre", def: "Stages de football — U8 à U13" },
      { key: "stagepayet.title", label: "Grand titre (2ème ligne en or)", multiline: true, def: "STAGE\nPAYET" },
      { key: "stagepayet.subtitle", label: "Description sous le titre", multiline: true, def: "Des stages de perfectionnement haut de gamme sur la Côte d'Azur : éducateurs diplômés, groupes réduits, progression individuelle et expérience inoubliable pour les jeunes joueurs." },
    ],
  },
  {
    group: "Stage Pro / Semi-Pro",
    fields: [
      { key: "stagepro.overline", label: "Sur-titre", def: "Haut niveau — encadrement professionnel" },
      { key: "stagepro.title", label: "Grand titre (2ème ligne en or)", multiline: true, def: "STAGE PRO\nSEMI-PRO" },
      { key: "stagepro.subtitle", label: "Description sous le titre", multiline: true, def: "Une immersion dans le quotidien du football professionnel : préparation athlétique, analyse vidéo, oppositions de haut niveau et encadrement par des professionnels du jeu." },
    ],
  },
  {
    group: "Matchs amicaux",
    fields: [
      { key: "matchs.overline", label: "Sur-titre", def: "Professionnels & semi-professionnels" },
      { key: "matchs.title", label: "Grand titre (2ème ligne en or)", multiline: true, def: "MATCHS\nAMICAUX" },
      { key: "matchs.subtitle", label: "Description sous le titre", multiline: true, def: "3M Match Pro organise vos matchs amicaux de A à Z : opposition de niveau, stade, arbitres, logistique et mise en scène. Vous jouez, nous nous occupons du reste." },
    ],
  },
  {
    group: "Qui sommes-nous",
    fields: [
      { key: "quisommesnous.overline", label: "Sur-titre", def: "La structure" },
      { key: "quisommesnous.title", label: "Grand titre (2ème ligne en or)", multiline: true, def: "QUI SOMMES-\nNOUS ?" },
      { key: "quisommesnous.subtitle", label: "Description sous le titre", multiline: true, def: "3M Match Pro est une structure spécialisée dans l'organisation de stages de football et de matchs amicaux professionnels et semi-professionnels." },
    ],
  },
  {
    group: "Sponsors / Partenaires",
    fields: [
      { key: "sponsors.overline", label: "Sur-titre", def: "Ils nous font confiance" },
      { key: "sponsors.title", label: "Grand titre (2ème ligne en or)", multiline: true, def: "NOS SPONSORS\n& PARTENAIRES" },
      { key: "sponsors.subtitle", label: "Description sous le titre", multiline: true, def: "Des partenaires qui partagent nos valeurs d'exigence et de performance, et qui accompagnent le développement de 3M Match Pro." },
    ],
  },
  {
    group: "Contact",
    fields: [
      { key: "contact.overline", label: "Sur-titre", def: "Une question, un projet ?" },
      { key: "contact.title", label: "Grand titre (2ème ligne en or)", multiline: true, def: "CONTACTEZ-\nNOUS" },
      { key: "contact.subtitle", label: "Description sous le titre", multiline: true, def: "Stages, matchs amicaux, partenariats ou boutique : écrivez-nous, nous répondons rapidement à toutes les demandes." },
    ],
  },
  {
    group: "Boutique",
    fields: [
      { key: "boutique.overline", label: "Sur-titre", def: "3M Match Pro — Le shop officiel" },
      { key: "boutique.title", label: "Grand titre", multiline: true, def: "BOUTIQUE" },
      { key: "boutique.description", label: "Description", multiline: true, def: "Maillots, tenues de stage et accessoires officiels 3M Match Pro : la boutique en ligne ouvrira prochainement. Laissez-nous un message pour être informé du lancement." },
    ],
  },
  {
    group: "Équipementier sportif",
    fields: [
      { key: "equipementier.overline", label: "Sur-titre", def: "Partenariat équipement" },
      { key: "equipementier.title", label: "Grand titre", multiline: true, def: "ÉQUIPEMENTIER\nSPORTIF" },
      { key: "equipementier.description", label: "Description", multiline: true, def: "Notre offre équipementier pour les clubs et les stagiaires arrive bientôt : tenues personnalisées, packs clubs et matériel aux couleurs 3M Match Pro." },
    ],
  },
];
